import Lookup from 'src/componentes/select2';
import PerspectivaEdit from 'src/paginas/perspectiva/edit';

const PerspectivaLookup = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/PerspectivaLookup"
      editComponent={PerspectivaEdit}
      {...props}
    />
  );
};

export default PerspectivaLookup;
